import { LOGIN } from "lib/routes";
import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "hooks/auth";
import Navbar from "components/layout/Navbar";
import Swal from "sweetalert2";
import Header from "./Header";



export default function Layout() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { user, isLoading } = useAuth();

  console.log("🏠 Layout render:", { pathname, user: user?.username, isLoading });

  useEffect(() => {
    console.log("🔒 Layout auth check:", { isLoading, pathname, user: user?.username });
    if (!isLoading && pathname.startsWith("/protected") && !user) {
      console.log("⚠️ No user found, redirecting to LOGIN");
      navigate(LOGIN);
    }
  }, [pathname, user, isLoading]);

    if (isLoading) {
      console.log("⏳ Showing loading modal...");
      Swal.fire({
        title: 'Loading auth user...',
        html: 'Please wait...',
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
    } else {
      console.log("✅ Auth loaded, closing modal");
      Swal.close();
    }



  return (
    <>
     <Header/>
      <div >
      <Outlet />
      <Navbar />
      </div>
    </>
  );
}
